import { graphql } from "gatsby";
import React from "react";

import type { HomeVideoDataFragment } from "../../../graphql-types";
import { VideoPlayer } from "../../components/VideoPlayer";

type Props = {
  video: HomeVideoDataFragment;
};

const HomeVideo: React.FC<Props> = ({ video }) => (
  <div className="home-video">
    {video.title && (
      <h2 className="text-center uppercase title">{video.title}</h2>
    )}
    {video.video.cdnVideo && (
      <div className="max-w-container px-10 pb-20 mx-auto">
        <VideoPlayer
          data-testid="video"
          path={video.video.cdnVideo.path}
          poster={video.video.cdnVideo.posterPath}
        />
        {video.description && (
          <h2 className="pt-5 font-bold text-center text-md">
            {video.description}
          </h2>
        )}
      </div>
    )}
  </div>
);

export const fragments = graphql`
  fragment HomeVideoData on Video {
    title
    description
    video {
      cdnVideo {
        path
        posterPath
      }
    }
  }
`;

export default HomeVideo;
